module.exports = __webpack_public_path__ + "static/media/autoconocimiento.39ad5a36.jpg";